import { createSlice } from "@reduxjs/toolkit";
import { getPermisionList } from "../../roles/services/role-service";

const initialState = {
    permissions: [],
    permission: null,
    pagination: null,
    error: [],
    loading: false,
    responseMessage: null,
    success: false,
    successMessage: null,
    deleteResponse: false,
    errorMessage: null,
};

export const permissionslice = createSlice({
    name: "permission",
    initialState,
    reducers: {
        resetError(state) {
            state.errorMessage = null;
        },

        resetSuccess(state) {
            state.successMessage = null;
        },

        resetState(state) {
            state.success = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPermisionList.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getPermisionList.fulfilled, (state, action) => {
                state.permissions = action.payload.data.items;
                state.pagination = action.payload.data.item;
                state.currentPage = action.payload.data.item;
                state.loading = false;

            })
            .addCase(getPermisionList.rejected, (state, action) => {
                state.loading = false;
            })

    },
});
export const { resetSuccess, resetState, resetError } = permissionslice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export default permissionslice.reducer;
